module.exports = __webpack_public_path__ + "assets/img/new_ground.png?40e3b76fa89e91d6fcb4ee0a2b2d7bf6";